import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetAccessRolesDetailsDto from "./dto/get-access-roles.dto";

export const AccessRolesDetailsEffectActions = {
  getAccessRolesDetails: `${Entities.AccessRolesDetails}_getAccessRolesDetails`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.AccessRolesDetails,
  initSchema,
  aliasName: DIContainerKeys.AccessRolesDetailsService,
})
export class AccessRolesDetailsService extends HttpService {
  @loader(Loaders.GetAccessRolesDetailsLoader)
  @action(DIContainerKeys.AccessRolesDetailsService)
  public *getAccessRolesDetails(dto: GetAccessRolesDetailsDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetAccessRolesDetailsLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetAccessRolesDetails),
        domain: API_DOMENS.CC_API,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetAccessRolesDetailsLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.AccessRolesDetails, dto.clientId, response?.roles);
    yield this.setLoaderState(Loaders.GetAccessRolesDetailsLoader, false);
  }
}